import type { FC } from "react";
import { Route, Routes } from "react-router-dom";

import { CallbackPage } from "./pages/callback";
import { ContactPage } from "./pages/contact";
import { DashboardPage } from "./pages/dashboard";
import { DetailPage } from "./pages/detail";
import { ErrorHistoryPage } from "./pages/error-history";
import { RoomsPage } from "./pages/rooms";
import { TimeControlPage } from "./pages/time-control";
import { WorkplacesPage } from "./pages/workplaces";

const App: FC = () => (
  <Routes>
    <Route element={<CallbackPage />} path="/callback" />
    <Route element={<DashboardPage />} path="/" />
    <Route element={<WorkplacesPage />} path="/workplaces" />
    <Route element={<DetailPage />} path="/workplaces/:deviceId" />
    <Route element={<TimeControlPage />} path="/time" />
    <Route element={<ErrorHistoryPage />} path="/error-history" />
    <Route element={<ContactPage />} path="/contact" />
    <Route element={<RoomsPage />} path="/rooms" />
  </Routes>
);

export default App;
